import styled from 'styled-components';
var Flexbox = styled.div(function (_a) {
    var justifyContent = _a.justifyContent, alignContent = _a.alignContent, alignItems = _a.alignItems, flexFlow = _a.flexFlow, flexWrap = _a.flexWrap, flexDirection = _a.flexDirection, gap = _a.gap;
    return ({
        display: 'flex',
        justifyContent: justifyContent,
        alignContent: alignContent,
        alignItems: alignItems,
        flexFlow: flexFlow,
        flexWrap: flexWrap,
        flexDirection: flexDirection,
        gap: gap
    });
});
export default Flexbox;
//# sourceMappingURL=Flexbox.js.map